module.exports = __webpack_public_path__ + "img/snapchat-brands.c97e7d3.svg";